import { useInventoryConfigsGet } from "@dealer-center/ddc-pages-inventory-config-fetch";
import { LoadingIndicator } from "@dealer-center/core-custom-components";
import { PagesInventoryConfigUiConfigSelector } from "../ConfigSelector";
import { useContext } from "react";
import { configItemContext } from "../../ConfigArea/inputList";
import { Alert } from "@dealer-center/core-components";

interface ImportModalConfigInterface {
  setSelectedConfigName: (value: string) => void;
  selectedAccount: string;
  selectedConfigName: string;
}
export const ImportModalConfig = ({
  setSelectedConfigName,
  selectedAccount,
  selectedConfigName
}: ImportModalConfigInterface) => {
  const { data: configList, isLoading } =
    useInventoryConfigsGet(selectedAccount);
  const { setIsNewConfig } = useContext(configItemContext);
  return isLoading ? (
    <LoadingIndicator actionName="Loading Inventory Imports Configs" />
  ) : configList?.length === 0 ? (
    <Alert role="alert" sx={{ marginBottom: "16px" }} type="info">
      No configs found for {selectedAccount}
    </Alert>
  ) : selectedAccount ? (
    <PagesInventoryConfigUiConfigSelector
      allowNewEntry={false}
      dealerEntityId={selectedAccount}
      id="import-modal-config-selector"
      selectedConfigName={selectedConfigName}
      setIsNewConfig={setIsNewConfig}
      setSelectedConfigName={setSelectedConfigName}
    />
  ) : null;
};
